export function stripLeadingSlash(str: string) {
    return str.replace(/^\/+/, "");
}
